import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { useForm } from "react-hook-form";
import { JVDropdown } from "../../shared/JVDropdown";
import { Fetch } from "../../shared/Fetch";
import { LegalTask } from "../showPurchaseOrder/LegalTask";
import { JVInput } from "../../shared/JVInput";

interface IProps {
  open: boolean;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
  loadTableData: () => void;
}

interface IForm {
  sourceType: string;
  poId?: number;
  requirementId?: number;
}

const Form = (props: IProps) => {
  const [poList, setPoList] = useState<any[]>([]);
  const [requirementList, setRequirementList] = useState<any[]>([]);

  const { control, watch, reset } = useForm<IForm>({
    defaultValues: {
      sourceType: "",
      poId: undefined,
      requirementId: undefined,
    },
    shouldFocusError: false
  });

  const sourceType = watch("sourceType");
  const poId = watch("poId");
  const requirementId = watch("requirementId");

  const loadPOs = async () => {
    const response = await Fetch("Legal_Task/getPODropdown", "GET", null, null, props.toast);

    if (response?.ok) {
      const data = await response.json();
      setPoList(data);
    }
  };

  const loadRequirements = async () => {
    const response = await Fetch("Legal_Task/getReqDropdown", "GET", null, null, props.toast);

    if (response?.ok) {
      const data = await response.json();
      setRequirementList(data);
    }
  };
  useEffect(() => {
    if (sourceType === "PO") {
      loadPOs();
    } else if (sourceType === "REQ") {
      loadRequirements();
    }
  }, [sourceType]);

  useEffect(() => {
    if (!props.open) return;

    reset({
      sourceType: "",
      poId: undefined,
      requirementId: undefined,
    });
  }, [props.open]);

  return (
    <Dialog visible={props.open} header="Legal Task" style={{ width: "90vw" }} modal onHide={props.hideDialog}>
      <div className="p-fluid formgrid grid">
        <JVDropdown
          column={4}
          label="Source"
          control={control}
          name="sourceType"
          options={[
            { name: "From PO", value: "PO" },
            { name: "From Requirement", value: "REQ" },
            { name: "Other", value: "OTHER" },
          ]}
          optionLabel="name"
          optionValue="value"
          placeholder="Select Source Type"
        />
        {sourceType === "PO" && <JVDropdown filter column={4} label="Purchase Order" control={control} name="poId" options={poList} optionLabel="label" optionValue="pO_ID" />}
        {sourceType === "REQ" && <JVDropdown filter column={4} label="Requirement" control={control} name="requirementId" options={requirementList} optionLabel="label" optionValue="req_ID" />}
      </div>
      {sourceType === "PO" && poId && <LegalTask sourceType="PO" open={true} hideDialog={() => { }} hideDialogAb={() => {
        props.loadTableData();
        props.hideDialog();
      }} toast={props.toast} pO_ID={poId} type="PO" is_form={true} />}
      {sourceType === "REQ" && requirementId && <LegalTask sourceType="REQ" open={true} hideDialog={() => { }} hideDialogAb={() => {
        props.loadTableData();
        props.hideDialog();
      }} toast={props.toast} req_Id={requirementId} type="Requirement" is_form={true} />}
      {sourceType === "OTHER" && <LegalTask sourceType="OTHER" open={true} hideDialog={() => { }} hideDialogAb={() => {
        props.loadTableData();
        props.hideDialog();
      }} toast={props.toast} type="Other" is_form={true} />}
    </Dialog>
  );
};

export default Form;
